import { useLocalSearchParams } from 'expo-router';
import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

import { billReviewSourceAtom } from '../../../../bills/state/BillsAtoms';
import SpinwheelLanding from '../../../../onboarding/components/spinwheel/SpinwheelLanding';

export default function SpinwheelTestScreen() {
    const { source } = useLocalSearchParams<{ source?: string }>();
    const setBillReviewSource = useSetAtom(billReviewSourceAtom);

    useEffect(() => {
        if (source === 'before-money-map-session') {
            setBillReviewSource('home-review');
        } else if (source === 'home') {
            setBillReviewSource('home');
        }
    }, [source, setBillReviewSource]);

    return <SpinwheelLanding />;
}
